import { useAuth0User } from '@/app/modules/Context/useAuth0User';
import { User } from '@/types/user';
import { useMemo } from 'react';

export interface UseUserDisplayInfoReturn {
  user: User | null;
  isUserLoggedIn: boolean;
  userInitials: string;
}

export const useUserDisplayInfo = (): UseUserDisplayInfoReturn => {
  const { user } = useAuth0User();

  const isUserLoggedIn = !!user;

  const userInitials = useMemo(() => {
    const trimmedGivenName = user?.given_name?.trim();
    const trimmedFamilyName = user?.family_name?.trim();

    if (!trimmedGivenName || !trimmedFamilyName) {
      return '';
    }
    return `${trimmedGivenName.charAt(0)}${trimmedFamilyName.charAt(0)}`.toUpperCase();
  }, [user?.given_name, user?.family_name]);

  return {
    user,
    isUserLoggedIn,
    userInitials,
  };
};
